import { render, staticRenderFns } from "./goods-pool.vue?vue&type=template&id=3eaf030a"
import script from "./goods-pool.vue?vue&type=script&lang=js"
export * from "./goods-pool.vue?vue&type=script&lang=js"
import style0 from "./goods-pool.vue?vue&type=style&index=0&id=3eaf030a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports